import { fetchGetOnlineAccount } from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import {
    getOpenBankingStatus,
    OpenBankingStatus
} from './getOpenBankingStatus';
import { useStateKey } from '../../iwQueryClient/useStateKey';

export const useGetOpenBankingStatus = (): OpenBankingStatus => {
    const stateKey = useStateKey();

    const { data } = useQuery({
        queryKey: ['online_accounts', stateKey],
        queryFn: () => fetchGetOnlineAccount({ stateKey }),
        suspense: true
    });

    return getOpenBankingStatus(data!.data);
};
